import React, { useContext, useEffect } from "react"
import { InterfaceContext } from "../../context/InterfaceContext"
import {
  allPreferencesAccepted,
  onlyNecessaryPreferences,
  saveCookiePreferences,
} from "./utils"
import { resolveLegalLink } from "../../util/legal-pages"
import { ButtonAction } from "../button/ButtonAction"
import { ButtonNeutral } from "../button/ButtonNeutral"
import { ButtonTransparent } from "../button/ButtonTransparent"
import { useTranslation } from "react-i18next"
import { translationKeys } from "../../util/translationKeys"
import { BodyTextRegular } from "../typography/text"
import i18n from "../../i18n"

const cookiesLink = resolveLegalLink("cookies")

export const CookieBanner = () => {
  const isConsentRequired = !localStorage.getItem("cookiePreferences")

  const { t } = useTranslation()

  const { setCookieModalVisible, cookieBannerVisible, setCookieBannerVisible } =
    useContext(InterfaceContext)

  useEffect(() => {
    setCookieBannerVisible(isConsentRequired)
  }, [])

  if (!cookieBannerVisible) {
    return <></>
  }

  return (
    <div className="fixed items-center md:items-end gap-4 flex-col rounded p-6 bottom-4 md:bottom-10 md:right-10 shadow-flyout z-top flex w-full md:w-1/2 bg-backgroundBranded">
      <BodyTextRegular>
        {t(translationKeys.comboCookiesDescription)}{" "}
        {cookiesLink ? (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={
              cookiesLink.internal
                ? `/${i18n.language}${cookiesLink.href}` // explicitly setting locale since custom i18n provider from /i18n.ts does not fill it in like gatsby i18n provider
                : cookiesLink.href
            }
            className="cursor-pointer text-blue-800 underline"
          >
            {t(translationKeys.comboCookiesPolicy)}
          </a>
        ) : (
          <span>{t(translationKeys.comboCookiesPolicy)}</span>
        )}
        .
      </BodyTextRegular>
      <div className="flex flex-col md:flex-row gap-3 w-full">
        <ButtonAction
          onClick={() => {
            saveCookiePreferences(allPreferencesAccepted)
            setCookieBannerVisible(false)
          }}
          size="large"
        >
          {t(translationKeys.comboAccept)}
        </ButtonAction>
        <ButtonNeutral
          onClick={() => {
            setCookieBannerVisible(false)
            setCookieModalVisible(true)
          }}
          size="large"
        >
          {t(translationKeys.comboManage)}
        </ButtonNeutral>
        <ButtonTransparent
          onClick={() => {
            saveCookiePreferences(onlyNecessaryPreferences)
            setCookieBannerVisible(false)
          }}
          size="large"
        >
          {t(translationKeys.comboCookiesNecessary)}
        </ButtonTransparent>
      </div>
    </div>
  )
}
